import React, { useContext, useEffect, useState, Suspense } from 'react'
import styles from './QuizChallenges.module.css'
import { LuClock3 } from "react-icons/lu";
import { GrCircleQuestion } from "react-icons/gr";
import { dataContext } from '../../../App'
import { convertToBengaliNumber } from '../helper';
import activityLogSubmission from '../../../helper/activitylog';
import { fakeRules as originalEvents } from '../../../assets/fakeData/fakeRules';

const RealSwiper = React.lazy(() => import('./RealSwiper'));

const QuizChallenges = ({ quizClickHandler, setShowShobDekho, donotShowSwiper }) => {
  const { playerData } = useContext(dataContext);
  const [loadSwiper, setLoadSwiper] = useState(false);

  const events = originalEvents;

  useEffect(() => {
    let triggered = false;
    let timer;
    const triggerLoad = () => {
      if (!triggered) {
        triggered = true;
        setLoadSwiper(true);
        ['scroll', 'touchstart', 'mousemove', 'keydown', 'click'].forEach(e =>
          window.removeEventListener(e, triggerLoad)
        );
      }
    };

    ['scroll', 'touchstart', 'mousemove', 'keydown', 'click'].forEach(e =>
      window.addEventListener(e, triggerLoad, { passive: true, once: true })
    );

    timer = setTimeout(triggerLoad, 3000);

    return () => {
      clearTimeout(timer);
      ['scroll', 'touchstart', 'mousemove', 'keydown', 'click'].forEach(e =>
        window.removeEventListener(e, triggerLoad)
      );
    };
  }, []);

  const renderSingleCard = (event, eager = false) => (
    <div key={event.id} className={styles.quizCard} onClick={() => { quizClickHandler(event.id, playerData); activityLogSubmission(`quiz-banner-${event.id}`, playerData?.msisdn) }}>
      <img
        src={event.banner_url}
        alt={event.events}
        className={styles.bannerImage}
        loading={eager ? "eager" : "lazy"}
        fetchpriority={eager ? "high" : "auto"}
      />
      <div className={styles.quizInfo}>
        <h3 className={styles.quizTitle}>{event.events}</h3>
        <div className={styles.quizMeta}>
          <div className={styles.metaItem}>
            <LuClock3 className={styles.icon} />
            <span>{convertToBengaliNumber(event.allocated_time)} সে.</span>
          </div>
          <div className={styles.metaItem}>
            <GrCircleQuestion className={styles.icon} />
            <span>{convertToBengaliNumber(event.question_set)}টি প্রশ্ন</span>
          </div>
          <button className={styles.playButton}>
            খেলুন →
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={donotShowSwiper ? styles.quizChallengesCategory : styles.quizChallenges}>
      <div className={styles.header} style={{ padding: donotShowSwiper ? '0px 16px' : '0px 16px', marginBottom: donotShowSwiper ? '0px' : '16px' }}>
        <h2 className={styles.title}>কুইজ চ্যালেঞ্জেস</h2>
        {/* <a href="#" className={styles.viewAll} onClick={() => setShowShobDekho(true)}>সবগুলো দেখো</a> */}
      </div>

      {!donotShowSwiper && events?.length > 0 && (
        <>
          {(!loadSwiper || events.length === 1) && (
            <div style={{ padding: '0 16px', marginBottom: events.length > 1 ? '16px' : '0', width: '86%' }}>
              {renderSingleCard(events[0], true)}
            </div>
          )}
          {events?.length > 1 && loadSwiper && (
            <Suspense fallback={
              <div style={{ padding: '0 16px', marginBottom: '16px', width: '86%' }}>
                {renderSingleCard(events[0], true)}
              </div>
            }>
              <RealSwiper events={events} quizClickHandler={quizClickHandler} playerData={playerData} />
            </Suspense>
          )}
        </>
      )}

      {(donotShowSwiper === true) && (
        <div style={{ padding: '0 16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {events?.map((event) => renderSingleCard(event))}
        </div>
      )}
    </div>
  )
}

export default QuizChallenges